import type { Step } from '@de/types/types';

interface InitializeCurrentStepParams {
  steps: Step[];
  jumpToStepId?: string;
  fromStepIndex?: number;
}

export const initializeCurrentStep = ({
  steps,
  jumpToStepId,
  fromStepIndex,
}: InitializeCurrentStepParams): {
  currentStep: Step;
  currentStepIndex: number;
} => {
  if (jumpToStepId) {
    const stepIndex = steps.findIndex((step) => step.id === jumpToStepId);
    if (stepIndex !== -1) {
      return {
        currentStep: steps[stepIndex],
        currentStepIndex: fromStepIndex ? fromStepIndex + 1 : 1,
      };
    }
  }

  // Default to first step
  return {
    currentStep: steps[0],
    currentStepIndex: 1,
  };
};
